import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import LeadEmailForm from './LeadEmailForm';
import safeStorage from '../utils/safeStorage';

// Exit-intent popup — when the cursor leaves toward the browser chrome
// (closing the tab / typing a new URL), offer a free sample story by email.
// Desktop only (mobile has no reliable exit signal). Shown at most once
// every 7 days per browser, never to logged-in users.
const STORAGE_KEY = 'db_exit_intent_at';
const SHOW_AGAIN_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

const ExitIntentPopup = () => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (user) return undefined;
    if (!window.matchMedia?.('(pointer: fine)').matches) return undefined; // desktop only

    const lastShown = parseInt(safeStorage.getItem(STORAGE_KEY) || '0', 10);
    if (Date.now() - lastShown < SHOW_AGAIN_AFTER_MS) return undefined;

    const onMouseOut = (e) => {
      // Fires when the cursor leaves the document toward the top (tab bar / URL bar)
      if (!e.relatedTarget && e.clientY <= 10) {
        safeStorage.setItem(STORAGE_KEY, String(Date.now()));
        setVisible(true);
        document.removeEventListener('mouseout', onMouseOut);
      }
    };
    document.addEventListener('mouseout', onMouseOut);
    return () => document.removeEventListener('mouseout', onMouseOut);
  }, [user]);

  if (!visible) return null;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) setVisible(false); }}
      style={{position:'fixed', inset:0, background:'rgba(15,11,30,0.7)', zIndex:2000,
        display:'flex', alignItems:'center', justifyContent:'center', padding:'16px',
        backdropFilter:'blur(4px)'}}
    >
      <div className="card border-0 shadow-lg p-4 p-md-5 position-relative"
        style={{borderRadius:'24px', background:'var(--card-bg)', maxWidth:'520px', width:'100%'}}>
        <button
          type="button"
          aria-label="Close"
          className="btn position-absolute"
          style={{top:'12px', right:'14px', fontSize:'20px', color:'var(--text-soft)', lineHeight:1}}
          onClick={() => setVisible(false)}
        >
          ✕
        </button>

        <div className="text-center mb-3">
          <div style={{fontSize:'44px', marginBottom:'8px'}}>🌙</div>
          <h4 className="fw-bold mb-2" style={{fontFamily:"'Fredoka One',cursive", color:'var(--text-main)'}}>
            Wait — before you go…
          </h4>
          <p style={{color:'var(--text-muted2)', fontSize:'14px', margin:0}}>
            Get a free bedtime story sample emailed to you. See the magic before you decide — no signup needed.
          </p>
        </div>

        <LeadEmailForm source="exit_intent" askName askAge buttonLabel="📬 Send my free story" />
      </div>
    </div>
  );
};

export default ExitIntentPopup;
